import {
    fetchRoomProducts as apiFetchRoomProducts,
    addRoomProduct as apiAddRoomProduct,
    updateRoomProduct as apiUpdateRoomProduct,
    deleteRoomProduct as apiDeleteRoomProduct,
  } from '../../api/roomProduct';
  
  // Action Types
  export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
  export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
  export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
  export const ADD_PRODUCT_REQUEST = 'ADD_PRODUCT_REQUEST';
  export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
  export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';
  export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
  export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
  export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
  export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
  export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
  export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
  
  // Action Creators
  export const fetchProductsRequest = () => ({
    type: FETCH_PRODUCTS_REQUEST,
  });
  
  export const fetchProductsSuccess = (products) => ({
    type: FETCH_PRODUCTS_SUCCESS,
    payload: products,
  });
  
  export const fetchProductsFailure = (error) => ({
    type: FETCH_PRODUCTS_FAILURE,
    payload: error,
  });
  
  export const addProductRequest = () => ({
    type: ADD_PRODUCT_REQUEST,
  });
  
  export const addProductSuccess = (product) => ({
    type: ADD_PRODUCT_SUCCESS,
    payload: product,
  });
  
  export const addProductFailure = (error) => ({
    type: ADD_PRODUCT_FAILURE,
    payload: error,
  });
  
  export const updateProductRequest = () => ({
    type: UPDATE_PRODUCT_REQUEST,
  });
  
  export const updateProductSuccess = (product) => ({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: product,
  });
  
  export const updateProductFailure = (error) => ({
    type: UPDATE_PRODUCT_FAILURE,
    payload: error,
  });
  
  export const deleteProductRequest = () => ({
    type: DELETE_PRODUCT_REQUEST,
  });
  
  export const deleteProductSuccess = (id) => ({
    type: DELETE_PRODUCT_SUCCESS,
    payload: id,
  });
  
  export const deleteProductFailure = (error) => ({
    type: DELETE_PRODUCT_FAILURE,
    payload: error,
  });
  
  // Thunks
  export const fetchRoomProducts = () => async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const products = await apiFetchRoomProducts();
      dispatch(fetchProductsSuccess(products.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
  
  export const addRoomProduct = (product) => async (dispatch) => {
    dispatch(addProductRequest());
    try {
      const newProduct = await apiAddRoomProduct(product);
      dispatch(addProductSuccess(newProduct));
    } catch (error) {
      dispatch(addProductFailure(error.message));
    }
  };
  
  export const updateRoomProduct = (id, product) => async (dispatch) => {
    dispatch(updateProductRequest());
    try {
      const updatedProduct = await apiUpdateRoomProduct(id, product);
      dispatch(updateProductSuccess(updatedProduct));
    } catch (error) {
      dispatch(updateProductFailure(error.message));
    }
  };
  
  export const deleteRoomProduct = (id) => async (dispatch) => {
    dispatch(deleteProductRequest());
    try {
      await apiDeleteRoomProduct(id);
      dispatch(deleteProductSuccess(id));
    } catch (error) {
      dispatch(deleteProductFailure(error.message));
    }
  };
  